const initConfig = {
  file: "",
  email: "",
  campaign_name: "",
  start_date: "",
  end_date: "",
  campaign_description: "",
  target_service: "",
  target_parameter: [],
  successful_ref_bonus: "",
  increment_eligibility_timeline_type: "",
  ref_claim_end_date: "",
  eligibility_count: "",
  will_target_val_check: false,
  increment_amount_value: "",
  increment_count_value: "",
  increment_mau_value: "",
  rejection_reason: [],
};

export default initConfig;
